import {MatDialog} from '@angular/material/dialog';
import {MatDialogRef} from '@angular/material';
import {GeneralMessageDialogComponent} from '@shared/components/general-message-dialog/general-message-dialog.component';
import {Observable, of, throwError} from 'rxjs';
import {GeneralMessageModel} from '../general-message-dialog/general-message-dialog.component';
import {PlaceRepair} from '../../../claims/claims-commons/models/appointment-repair.model';
import {Place} from '../../../appointments/models/appointment.model';
/// <reference types="@types/googlemaps" />
import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	NgZone,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import {Utilities} from '@shared/utilities/utilities.model';

import {FormControl, Validators} from '@angular/forms';
import {MapsAPILoader} from '@agm/core';
import {PermissionService} from '@shared/service/permission.service';
import {AutoCompleteItemModel} from '@shared/components/autocomplete/autocomplete.component';
import {NgxPaginationConfig} from '@shared/models/ngx-pagination-config';
import {CommodityModel} from '@shared/models/commodity.model';
import {catchError, debounceTime, distinctUntilChanged, takeWhile, tap} from 'rxjs/operators';
import {PermissionFilterModel} from '@shared/models/permission-filter.model';
import {MatOptionSelectionChange} from '@angular/material/core';
import {NemoModuleKeys} from '@shared/models/user-permission.model';
import { TranslateContext } from '@shared/pipes/translate.pipe';

export interface Range {
	label: string;
	value: number;
}

@Component({
	selector: 'amd-find-center',
	templateUrl: './find-center.component.html',
	styleUrls: ['./find-center.component.scss']
})
export class FindCenterComponent implements OnInit, OnChanges {

	static CENTER_CLASS_DEFAULT: string = 'amd-link amd-link--border amd-link--station';
	static CENTER_CLASS_SELECTED: string = 'amd-link amd-link--border amd-link--station amd-link--active';

	@Input() accordionDisabled: boolean = false;
	@Input() accordionExpanded: boolean = false;
	@Input() resetCenterSelected: boolean;
	@Input() placeDelivery: Place;
	@Input() isComunicationVisible: boolean = true;
	@Input() displayPhoneNumber: boolean = false;
	@Output() centerSelectEventEmitter: EventEmitter<PlaceRepair> = new EventEmitter<PlaceRepair>();
	@Output() accordionExpandedEventEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() OpenRepairerDialog: EventEmitter<any> = new EventEmitter<any>();
	@ViewChild('searchAddress') searchAddress: ElementRef;

	paginator: NgxPaginationConfig = {
		itemsPerPage: 6,
		autoHide: true,
		previousLabel: '',
		nextLabel: '',
		screenReaderPageLabel: 'Paginazione',
		screenReaderCurrentLabel: 'Pagina',
		maxSize: 100,
	};
	currentPage: number;
	mapItemsClasses: Map<string, string> = null;
	previousCenter: Place;
	address: string;
	places: PlaceRepair[];
	placeSelected: any;
	latlngBounds: any;
	searchControl: FormControl;
	rangeControl: FormControl;
	place: google.maps.LatLng;
	autocomplete: any;
	formIsValid: boolean = false;
	rangeValues: Range[] = [
		{label: '25km', value: 25000},
		{label: '50km', value: 50000},
		{label: '100km', value: 100000},
		{label: '200km', value: 200000},
	];
	rangeSelected: number = this.rangeValues[0].value;
	searchByName: string = 'byName';
	searchByAddress: string = 'byAddress';
	modelAutoComplete: string;
	listFormAutoComplete: AutoCompleteItemModel[];
	commoditySelected: CommodityModel;
	searchCenterType: string;

	searchElementRef: ElementRef;
	commodityControl: FormControl = new FormControl(undefined, Validators.minLength(3));
	filteredOptions: Observable<CommodityModel[]>;
	showLoader: boolean = false;
	showSearchLoader: boolean = false;
	translateContext = TranslateContext;

	constructor(
		private mapsAPILoader: MapsAPILoader,
		public permissionService: PermissionService,
		private ngZone: NgZone,
		public _dialog: MatDialog,
	) {
	}

	ngOnInit(): void {
		this.setAutocompleteCommodities();
		this.searchControl = new FormControl('', [Validators.required]);
		this.searchCenterType = this.searchByAddress;

		this.mapsAPILoader.load().then(() => {
			this.autocomplete = new google.maps.places.Autocomplete(
				this.searchAddress.nativeElement,
				{}
			);

			this.autocomplete.setComponentRestrictions({country: 'it'});

			this.autocomplete.addListener('place_changed', () => {
				this.ngZone.run(() => {
					if (
						!Utilities.isVoid(this.autocomplete.getPlace()) &&
						!Utilities.isVoid(this.autocomplete.getPlace().geometry) &&
						!Utilities.isVoid(this.autocomplete.getPlace().geometry.location)
					) {
						this.place = this.autocomplete.getPlace().geometry.location;
					} else {
						this.place = null;
					}
					if (this.place === undefined || this.place === null) {
						this.searchControl.setErrors({ErrorSearch: true});
						this.formIsValid = false;
						this.places = [];
						return;
					} else {
						this.searchAddress.nativeElement.blur();
						this.formIsValid = true;
					}
				});
			});
		});
	}

	autoCompleteChangedField(event: any): void {
		if (!Utilities.isVoid(event.value)) {
			this.commoditySelected = event.value;
		} else {
			this.commoditySelected = null;
		}
	}

	setAutocompleteCommodities(): void {
		this.commodityControl.valueChanges
			.pipe(
				distinctUntilChanged(),
				debounceTime(1000)
			).subscribe(value => {
			if (this.commodityControl.valid && !Utilities.isVoid(value) && value !== '' && typeof value === 'string') {
				this.commoditySelected = null;
				this.showLoader = true;
				this.commodityControl.disable();
				this.filteredOptions = this.permissionService.getCommodityList(new PermissionFilterModel({name: value, type_ids: [2]})).pipe(
					takeWhile(() => !Utilities.isVoid(value) && value !== '' && typeof value === 'string'),
					catchError(() => {
						this.showLoader = false;
						this.commodityControl.enable();
						this.commodityControl.setErrors({'notFound': true});
						return of([]);
					}),
					tap((commodities: CommodityModel[]) => {
						this.showLoader = false;
						this.commodityControl.enable();
						if (!commodities || (commodities && commodities.length === 0)) {
							this.commodityControl.setErrors({'notFound': true});
						}
					})
				);
			} else {
				this.filteredOptions = of([]);
			}
		});
		this.modelAutoComplete = '';
		// this.permissionService
		// 	.getAllCommoditiesForAutocomplete()
		// 	.subscribe(commodities => {
		this.listFormAutoComplete = [];
		// 	});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!Utilities.isVoid(changes.resetCenterSelected)) {
			this.resetCenterSelected = changes.resetCenterSelected.currentValue;
			if (this.resetCenterSelected) {
				this.activateCenter(null);
			}
		}
	}

	findCenters(): void {
		if (this.searchCenterType === this.searchByAddress) {
			this.showSearchLoader = true;
			if (!Utilities.isVoid(this.place)) {
				const lng: string = this.place.toJSON().lng.toFixed(2);
				const lat: string = this.place.toJSON().lat.toFixed(2);
				if (!Utilities.isVoid(lat) && !Utilities.isVoid(lng)) {
					this.permissionService
						.getCommoditiesByAddressForSuperUser(NemoModuleKeys.CLAIMS, lat, lng, this.rangeSelected)
						.pipe(
							catchError(err => {
								this.showSearchLoader = false;
								this.places = [];
								return throwError(err);
							})
						)
						.subscribe(commodities => {
							this.showSearchLoader = false;
							if (commodities && commodities.length) {
								this.places = commodities.map(center => this.getPlaceRepairFromCommodity(center));
							} else {
								this.places = [];
							}
							this.initializeClasses();
						});
				}
			}
		} else if (this.searchCenterType === this.searchByName) {
			this.showSearchLoader = true;
			this.permissionService.getCommodityList(new PermissionFilterModel({ald_commodity_id: this.commoditySelected.ald_commodity_id}))
				.pipe(
					catchError(err => {
						this.showSearchLoader = false;
						this.places = [];
						return throwError(err);
					})
				).subscribe(commodities => {
				this.showSearchLoader = false;
				if (commodities && commodities.length) {
					this.places = commodities.map(center => this.getPlaceRepairFromCommodity(center));
				} else {
					this.places = [];
				}
				this.initializeClasses();
			});
		}
	}

	activateCenter(center: PlaceRepair): void {
		if (!Utilities.isVoid(center)) {
			if (this.previousCenter !== center) {
				this.openSelectCenterMessageDialog(this.confirmSelectCenter(center)).subscribe(result => {
					if (result) {
						this.mapItemsClasses.set(center.place_id, FindCenterComponent.CENTER_CLASS_SELECTED);
						if (!Utilities.isVoid(this.previousCenter)) {
							this.mapItemsClasses.set(this.previousCenter.place_id, FindCenterComponent.CENTER_CLASS_DEFAULT);
						}
						this.centerSelectEventEmitter.emit(center);
						this.previousCenter = center;
					}
				});
			}
		}
	}

	private initializeClasses(): void {
		this.mapItemsClasses = new Map<string, string>();
		for (let i: number = 0; i < this.places.length; i++) {
			if (this.placeDelivery && this.places[i].place_id === this.placeDelivery.place_id) {
				this.mapItemsClasses.set(this.places[i].place_id, FindCenterComponent.CENTER_CLASS_SELECTED);
				this.previousCenter = this.places[i];
			} else {
				this.mapItemsClasses.set(this.places[i].place_id, FindCenterComponent.CENTER_CLASS_DEFAULT);
			}
		}
	}

	openRepairerEmailDialog(): void {
		this.OpenRepairerDialog.emit();
	}

	confirmSelectCenter(center: PlaceRepair): GeneralMessageModel {
		const generalMessage: GeneralMessageModel = new GeneralMessageModel();
		generalMessage.title = GeneralMessageModel.TITLE_WARNING;
		generalMessage.txts = [GeneralMessageModel.TXT_CONFIRM_CENTER];
		generalMessage.buttons = [
			{
				txt: GeneralMessageModel.TXT_BUTTON_OK,
				style: GeneralMessageModel.BUTTON_STYLE_RAISED,
				action: true
			},
			{
				txt: GeneralMessageModel.TXT_BUTTON_CANCEL,
				style: GeneralMessageModel.BUTTON_STYLE_REVERSE,
				action: false
			}
		];
		generalMessage.showCloseButton = true;
		generalMessage.type = GeneralMessageModel.MESSAGE_TYPE_3;
		generalMessage.params = [center.name];
		return generalMessage;
	}

	private openSelectCenterMessageDialog(generalMessage: GeneralMessageModel): Observable<any> {
		const dialogRef: MatDialogRef<GeneralMessageDialogComponent> = this._dialog.open(GeneralMessageDialogComponent, {
			height: 'auto',
			width: '400px',
			disableClose: false
		}) as MatDialogRef<GeneralMessageDialogComponent>;
		dialogRef.componentInstance.generalMessageDialog = generalMessage;
		return dialogRef.afterClosed();
	}

	displayCenter(center: CommodityModel): string {
		return center && center instanceof Object ? center.ald_commodity_id + ' - ' + center.name + ' - ' + center.address + ', ' + center.address_number + ', ' + center.municipality + ', ' + center.zip_code + ', ' + center.province_code
			: center && typeof center === 'string' ? center : '';
	}

	selectCenter(_event: MatOptionSelectionChange): void {
		if (_event.source.selected) {
			this.commoditySelected = _event.source.value;
		}
	}

	getPlaceRepairFromCommodity(center: CommodityModel): PlaceRepair {
		const place: PlaceRepair = new PlaceRepair();
		place.address = center.address;
		place.address_number = center.address_number;
		place.ald_commodity_id = center.ald_commodity_id;
		place.ald_supplier_code = center.ald_supplier_code;
		place.contact_phone = center.phone;
		place.distance = center.distance;
		place.has_dedicated_expert = center.flag_dedicated_expert;
		place.municipality = center.municipality;
		place.name = center.name;
		place.place_id = center.id;
		place.type = Place.TYPE_SERVICE_POINT;
		place.zip_code = center.zip_code;
		place.email = center.email;
		place.region = center.region;
		place.province_code = center.province_code;
		place.fiscal_code = center.fiscal_code;
		place.vat_number = center.vat_number;
		if (!Utilities.isVoid(center.distance)) {
			place.distance =
				Math.floor(center.distance) / 1000;
		}
		return place;
	}
}
